window.paragraphEditor = (() => {
    let _dotnetRef = null;
    let _editorEl = null;
    let _contextMenuHandler = null;
    let _documentClickHandler = null;
    let _pointerDownHandler = null;
    let _savedRange = null;

    function init(editorId, dotnetRef) {
        _cleanup();
        _dotnetRef = dotnetRef;
        _editorEl = document.getElementById(editorId);
        if (!_editorEl) {
            console.warn('paragraphEditor.init: container not found:', editorId);
            return;
        }
        console.log('paragraphEditor.init: attached to', editorId);

        _pointerDownHandler = (e) => {
            if (e.button === 2) {
                const sel = window.getSelection();
                if (sel && !sel.isCollapsed && sel.rangeCount > 0) {
                    _savedRange = sel.getRangeAt(0).cloneRange();
                    console.log('paragraphEditor: range saved, length:', _savedRange.toString().length);
                }
            }
        };
        document.addEventListener('pointerdown', _pointerDownHandler, true);

        _contextMenuHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();

            const paraEl = e.target.closest('[data-para-id]');
            if (!paraEl) {
                console.log('paragraphEditor: no [data-para-id] parent found');
                return;
            }

            const range = _savedRange;
            if (!range) {
                console.log('paragraphEditor: no saved range');
                return;
            }

            if (!paraEl.contains(range.startContainer)) {
                console.log('paragraphEditor: range start not inside paragraph');
                return;
            }

            const preRange = document.createRange();
            preRange.selectNodeContents(paraEl);
            preRange.setEnd(range.startContainer, range.startOffset);

            const start = preRange.toString().length;
            const paraText = paraEl.innerText;
            const length = Math.min(range.toString().length, paraText.length - start);

            console.log('paragraphEditor: invoking .NET, start:', start, 'length:', length);

            if (length === 0) return;

            _dotnetRef.invokeMethodAsync(
                'OnParagraphContextMenu',
                paraEl.dataset.paraId,
                start,
                length,
                e.clientX + 4,
                e.clientY + 4
            );
        };
        _editorEl.addEventListener('contextmenu', _contextMenuHandler);

        // Bubble phase (no capture) so Blazor stopPropagation works
        _documentClickHandler = () => {
            _dotnetRef && _dotnetRef.invokeMethodAsync('CloseContextMenu');
        };
        document.addEventListener('click', _documentClickHandler);
    }

    function flashYellow(elementId, durationMs) {
        const el = document.getElementById(elementId);
        if (!el) return;
        el.style.transition = 'none';
        el.style.backgroundColor = '#FEF08A';
        requestAnimationFrame(() => {
            setTimeout(() => {
                el.style.transition = `background-color ${durationMs}ms ease`;
                el.style.backgroundColor = '';
            }, 100);
        });
    }

    function getContent(elementId) {
        const el = document.getElementById(elementId);
        return el ? el.innerText : '';
    }

    function dispose() { _cleanup(); }

    function _cleanup() {
        if (_editorEl && _contextMenuHandler)
            _editorEl.removeEventListener('contextmenu', _contextMenuHandler);
        if (_pointerDownHandler)
            document.removeEventListener('pointerdown', _pointerDownHandler, true);
        if (_documentClickHandler)
            document.removeEventListener('click', _documentClickHandler);
        _editorEl = null;
        _contextMenuHandler = null;
        _pointerDownHandler = null;
        _documentClickHandler = null;
    }

    return { init, flashYellow, getContent, dispose };
})();